export { ManageDocumentPage } from './ManageDocumentPage'
